import { render, staticRenderFns } from "./AdminTrainingUserEditDialog.vue?vue&type=template&id=48b83c98&scoped=true"
import script from "./AdminTrainingUserEditDialog.vue?vue&type=script&lang=js"
export * from "./AdminTrainingUserEditDialog.vue?vue&type=script&lang=js"
import style0 from "./AdminTrainingUserEditDialog.vue?vue&type=style&index=0&id=48b83c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b83c98",
  null
  
)

export default component.exports